var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { provideIntlService, registerForIntl } from '@progress/kendo-react-intl';
import { FocusableUponSelection } from './base/FocusableUponSelection';
/**
 * Represents the ChatMessage component.
 */
var ChatMessage = /** @class */ (function (_super) {
    __extends(ChatMessage, _super);
    function ChatMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    ChatMessage.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: this.getClassNames(), tabIndex: this.props.tabIndex, onClick: function () { return _this.props.onRequestSelection(_this.props.item.selectionIndex); }, onFocus: function () { return _this.props.onRequestSelection(_this.props.item.selectionIndex); }, ref: function (el) { return _this.elementToFocus = el; } },
            this.getTimestampView(),
            this.getMainView(),
            this.getStatusView()));
    };
    ChatMessage.prototype.getMainView = function () {
        if (this.props.item.typing) {
            return (React.createElement("div", { className: "k-bubble" },
                React.createElement("div", { className: "k-typing-indicator" },
                    React.createElement("span", null),
                    React.createElement("span", null),
                    React.createElement("span", null))));
        }
        else if (this.props.template) {
            return React.createElement(this.props.template, { item: this.props.item });
        }
        else if (this.props.item.text) {
            return (React.createElement("div", { className: "k-bubble" }, this.props.item.text));
        }
        else {
            return null;
        }
    };
    ChatMessage.prototype.getTimestampView = function () {
        var result = null;
        if (this.props.item.timestamp) {
            result = (React.createElement("time", { className: "k-message-time", "aria-hidden": !this.props.selected }, provideIntlService(this).formatDate(this.props.item.timestamp, this.props.dateFormat)));
        }
        return result;
    };
    ChatMessage.prototype.getStatusView = function () {
        var result = null;
        if (this.props.item.status) {
            result = (React.createElement("span", { className: "k-message-status" }, this.props.item.status));
        }
        return result;
    };
    ChatMessage.prototype.getClassNames = function () {
        return classNames({ 'k-only': this.props.isOnlyItemInGroup }, { 'k-first': this.props.isFirstItemInGroup && !this.props.isOnlyItemInGroup }, { 'k-last': this.props.isLastItemInGroup && !this.props.isOnlyItemInGroup }, { 'k-state-selected': this.props.selected }, { 'k-state-focused': this.props.selected }, 'k-message');
    };
    /**
     * @hidden
     */
    ChatMessage.defaultProps = {
        dateFormat: 'g',
        tabIndex: -1
    };
    return ChatMessage;
}(FocusableUponSelection));
export { ChatMessage };
registerForIntl(ChatMessage);
//# sourceMappingURL=ChatMessage.js.map